<template>
    <div class="min-h-screen">
        <!-- 页面横幅 -->
        <Banner 
            :title="t('sustainability.title')"
            :subtitle="t('sustainability.subtitle')"
        />

        <!-- 可持续发展愿景 -->
        <section class="py-20">
            <div class="container mx-auto px-4">
                <div class="text-center mb-12">
                    <h2 class="text-3xl font-bold text-[#005005] mb-4 border-b-4 border-[#005005] inline-block pb-2">{{ t('sustainability.vision.title') }}</h2>
                    <p class="text-[#8d6e63] text-lg">{{ t('sustainability.vision.content') }}</p>
                </div>
                <div class="max-w-4xl mx-auto">
                    <div class="rounded-lg overflow-hidden shadow-lg mb-8">
                        <img src="/images/socialResponsibility/KeChiXuFaZhanSuoLve.png" :alt="t('sustainability.vision.imageAlt')" class="w-full">
                    </div>
                    <div class="bg-white p-8 rounded-lg shadow-lg mb-8">
                        <div class="space-y-6">
                            <p class="text-[#212121] text-lg">{{ t('sustainability.vision.intro1') }}</p>
                            <p class="text-[#212121] text-lg">{{ t('sustainability.vision.intro2') }}</p>
                            <p class="text-[#212121] text-lg">{{ t('sustainability.vision.intro3') }}</p>
                        </div>
                    </div>
                    
                    <div class="space-y-8">
                        <div class="bg-white p-8 rounded-lg shadow-lg">
                            <div class="flex items-center mb-4">
                                <div class="text-2xl text-[#005005] mr-4">
                                    <i class="fas fa-seedling"></i>
                                </div>
                                <h3 class="text-xl font-semibold text-[#005005]">{{ t('sustainability.vision.items.circular.title') }}</h3>
                            </div>
                            <p class="text-[#212121]">{{ t('sustainability.vision.items.circular.content') }}</p>
                        </div>

                        <div class="bg-white p-8 rounded-lg shadow-lg">
                            <div class="flex items-center mb-4">
                                <div class="text-2xl text-[#005005] mr-4">
                                    <i class="fas fa-users"></i>
                                </div>
                                <h3 class="text-xl font-semibold text-[#005005]">{{ t('sustainability.vision.items.innovation.title') }}</h3>
                            </div>
                            <p class="text-[#212121]">{{ t('sustainability.vision.items.innovation.content') }}</p>
                        </div>

                        <div class="bg-white p-8 rounded-lg shadow-lg">
                            <div class="flex items-center mb-4">
                                <div class="text-2xl text-[#005005] mr-4">
                                    <i class="fas fa-lightbulb"></i>
                                </div>
                                <h3 class="text-xl font-semibold text-[#005005]">{{ t('sustainability.vision.items.rural.title') }}</h3>
                            </div>
                            <p class="text-[#212121]">{{ t('sustainability.vision.items.rural.content') }}</p>
                        </div>

                        <div class="bg-white p-8 rounded-lg shadow-lg">
                            <div class="flex items-center mb-4">
                                <div class="text-2xl text-[#005005] mr-4">
                                    <i class="fas fa-handshake"></i>
                                </div>
                                <h3 class="text-xl font-semibold text-[#005005]">{{ t('sustainability.vision.items.cooperation.title') }}</h3>
                            </div>
                            <p class="text-[#212121]">{{ t('sustainability.vision.items.cooperation.content') }}</p>
                        </div>
                    </div>

                    <div class="bg-white p-8 rounded-lg shadow-lg mt-8">
                        <div class="flex items-center mb-4">
                            <div class="text-3xl text-[#005005] mr-4">
                                <i class="fas fa-bullseye"></i>
                            </div>
                            <h3 class="text-xl font-semibold text-[#005005]">{{ t('sustainability.vision.commitment.title') }}</h3>
                        </div>
                        <p class="text-[#212121] text-lg">{{ t('sustainability.vision.commitment.content') }}</p>
                    </div>
                </div>
            </div>
        </section>

        <!-- 清洁生产 -->
        <section class="py-20 bg-gray-50">
            <div class="container mx-auto px-4">
                <div class="text-center mb-12">
                    <h2 class="text-3xl font-bold text-[#005005] mb-4 border-b-4 border-[#005005] inline-block pb-2">{{ t('sustainability.cleanProduction.title') }}</h2>
                    <p class="text-[#8d6e63] text-lg">{{ t('sustainability.cleanProduction.subtitle') }}</p>
                </div>
                <div class="max-w-3xl mx-auto text-center mb-12">
                    <p class="text-[#212121] text-lg">{{ t('sustainability.cleanProduction.description') }}</p>
                </div>
                <div class="max-w-4xl mx-auto space-y-8">
                    <div class="bg-white p-8 rounded-lg shadow-lg">
                        <div class="flex items-center mb-4">
                            <div class="text-3xl text-[#005005] mr-4">
                                <i class="fas fa-industry"></i>
                            </div>
                            <h3 class="text-xl font-semibold text-[#005005]">{{ t('sustainability.cleanProduction.items.raw.title') }}</h3>
                        </div>
                        <div>
                            <p class="text-[#212121] mb-4">{{ t('sustainability.cleanProduction.items.raw.subtitle') }}</p>
                            <ul class="space-y-2">
                                <li class="flex items-start">
                                    <span class="text-[#005005] mr-2">•</span>
                                    <span class="text-[#212121]">{{ t('sustainability.cleanProduction.items.raw.points.0') }}</span>
                                </li>
                                <li class="flex items-start">
                                    <span class="text-[#005005] mr-2">•</span>
                                    <span class="text-[#212121]">{{ t('sustainability.cleanProduction.items.raw.points.1') }}</span>
                                </li>
                                <li class="flex items-start">
                                    <span class="text-[#005005] mr-2">•</span>
                                    <span class="text-[#212121]">{{ t('sustainability.cleanProduction.items.raw.points.2') }}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="bg-white p-8 rounded-lg shadow-lg">
                        <div class="flex items-center mb-4">
                            <div class="text-3xl text-[#005005] mr-4">
                                <i class="fas fa-leaf"></i>
                            </div>
                            <h3 class="text-xl font-semibold text-[#005005]">{{ t('sustainability.cleanProduction.items.process.title') }}</h3>
                        </div>
                        <div>
                            <p class="text-[#212121] mb-4">{{ t('sustainability.cleanProduction.items.process.subtitle') }}</p>
                            <ul class="space-y-2">
                                <li class="flex items-start">
                                    <span class="text-[#005005] mr-2">•</span>
                                    <span class="text-[#212121]">{{ t('sustainability.cleanProduction.items.process.points.0') }}</span>
                                </li>
                                <li class="flex items-start">
                                    <span class="text-[#005005] mr-2">•</span>
                                    <span class="text-[#212121]">{{ t('sustainability.cleanProduction.items.process.points.1') }}</span>
                                </li>
                                <li class="flex items-start">
                                    <span class="text-[#005005] mr-2">•</span>
                                    <span class="text-[#212121]">{{ t('sustainability.cleanProduction.items.process.points.2') }}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="bg-white p-8 rounded-lg shadow-lg">
                        <div class="flex items-center mb-4">
                            <div class="text-3xl text-[#005005] mr-4">
                                <i class="fas fa-recycle"></i>
                            </div>
                            <h3 class="text-xl font-semibold text-[#005005]">{{ t('sustainability.cleanProduction.items.recycle.title') }}</h3>
                        </div>
                        <div>
                            <p class="text-[#212121] mb-4">{{ t('sustainability.cleanProduction.items.recycle.subtitle') }}</p>
                            <ul class="space-y-2">
                                <li class="flex items-start">
                                    <span class="text-[#005005] mr-2">•</span>
                                    <span class="text-[#212121]">{{ t('sustainability.cleanProduction.items.recycle.points.0') }}</span>
                                </li>
                                <li class="flex items-start">
                                    <span class="text-[#005005] mr-2">•</span>
                                    <span class="text-[#212121]">{{ t('sustainability.cleanProduction.items.recycle.points.1') }}</span>
                                </li>
                                <li class="flex items-start">
                                    <span class="text-[#005005] mr-2">•</span>
                                    <span class="text-[#212121]">{{ t('sustainability.cleanProduction.items.recycle.points.2') }}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="bg-white p-8 rounded-lg shadow-lg">
                        <div class="flex items-center mb-4">
                            <div class="text-3xl text-[#005005] mr-4">
                                <i class="fas fa-home"></i>
                            </div>
                            <h3 class="text-xl font-semibold text-[#005005]">{{ t('sustainability.cleanProduction.items.product.title') }}</h3>
                        </div>
                        <div>
                            <p class="text-[#212121] mb-4">{{ t('sustainability.cleanProduction.items.product.subtitle') }}</p>
                            <ul class="space-y-2">
                                <li class="flex items-start">
                                    <span class="text-[#005005] mr-2">•</span>
                                    <span class="text-[#212121]">{{ t('sustainability.cleanProduction.items.product.points.0') }}</span>
                                </li>
                                <li class="flex items-start">
                                    <span class="text-[#005005] mr-2">•</span>
                                    <span class="text-[#212121]">{{ t('sustainability.cleanProduction.items.product.points.1') }}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- 循环经济 -->
        <section class="py-20">
            <div class="container mx-auto px-4">
                <div class="text-center mb-12">
                    <h2 class="text-3xl font-bold text-[#005005] mb-4 border-b-4 border-[#005005] inline-block pb-2">{{ t('sustainability.circularEconomy.title') }}</h2>
                    <p class="text-[#8d6e63] text-lg">{{ t('sustainability.circularEconomy.subtitle') }}</p>
                </div>
                <div class="max-w-4xl mx-auto">
                    <div class="rounded-lg overflow-hidden shadow-lg mb-8">
                        <img src="/images/socialResponsibility/XunHuanJingJiSuoLve.png" :alt="t('sustainability.circularEconomy.imageAlt')" class="w-full">
                    </div>
                    <div class="bg-white p-8 rounded-lg shadow-lg mb-8">
                        <div class="flex items-center mb-4">
                            <div class="text-3xl text-[#005005] mr-4">
                                <i class="fas fa-info-circle"></i>
                            </div>
                            <h3 class="text-xl font-semibold text-[#005005]">{{ t('sustainability.circularEconomy.intro.title') }}</h3>
                        </div>
                        <p class="text-[#8d6e63] text-lg">{{ t('sustainability.circularEconomy.intro.content') }}</p>
                    </div>
                    
                    <div class="space-y-8">
                        <div class="bg-white p-8 rounded-lg shadow-lg">
                            <div class="flex items-center mb-4">
                                <div class="text-2xl font-bold text-[#005005] mr-4">01</div>
                                <h4 class="text-xl font-semibold text-[#005005]">{{ t('sustainability.circularEconomy.items.source.title') }}</h4>
                            </div>
                            <div class="space-y-4">
                                <p class="text-[#212121]">{{ t('sustainability.circularEconomy.items.source.points.0') }}</p>
                                <p class="text-[#212121]">{{ t('sustainability.circularEconomy.items.source.points.1') }}</p>
                                <p class="text-[#212121]">{{ t('sustainability.circularEconomy.items.source.points.2') }}</p>
                            </div>
                        </div>

                        <div class="bg-white p-8 rounded-lg shadow-lg">
                            <div class="flex items-center mb-4">
                                <div class="text-2xl font-bold text-[#005005] mr-4">02</div>
                                <h4 class="text-xl font-semibold text-[#005005]">{{ t('sustainability.circularEconomy.items.core.title') }}</h4>
                            </div>
                            <div class="space-y-4">
                                <p class="text-[#212121]">{{ t('sustainability.circularEconomy.items.core.points.0') }}</p>
                                <p class="text-[#212121]">{{ t('sustainability.circularEconomy.items.core.points.1') }}</p>
                                <p class="text-[#212121]">{{ t('sustainability.circularEconomy.items.core.points.2') }}</p>
                            </div>
                        </div>

                        <div class="bg-white p-8 rounded-lg shadow-lg">
                            <div class="flex items-center mb-4">
                                <div class="text-2xl font-bold text-[#005005] mr-4">03</div>
                                <h4 class="text-xl font-semibold text-[#005005]">{{ t('sustainability.circularEconomy.items.upgrade.title') }}</h4>
                            </div>
                            <div class="space-y-4">
                                <p class="text-[#212121]">{{ t('sustainability.circularEconomy.items.upgrade.points.0') }}</p>
                                <p class="text-[#212121]">{{ t('sustainability.circularEconomy.items.upgrade.points.1') }}</p>
                                <p class="text-[#212121]">{{ t('sustainability.circularEconomy.items.upgrade.points.2') }}</p>
                            </div>
                        </div>
                    </div>

                    <div class="bg-white p-8 rounded-lg shadow-lg mt-8">
                        <div class="flex items-center mb-4">
                            <div class="text-3xl text-[#005005] mr-4">
                                <i class="fas fa-bullseye"></i>
                            </div>
                            <h3 class="text-xl font-semibold text-[#005005]">{{ t('sustainability.circularEconomy.vision.title') }}</h3>
                        </div>
                        <p class="text-[#212121] text-lg">{{ t('sustainability.circularEconomy.vision.content') }}</p>
                    </div>
                </div>
            </div>
        </section>

        <!-- 社会责任 -->
        <section class="py-20 bg-gray-50">
            <div class="container mx-auto px-4">
                <div class="text-center mb-12">
                    <h2 class="text-3xl font-bold text-[#005005] mb-4 border-b-4 border-[#005005] inline-block pb-2">{{ t('sustainability.socialResponsibility.title') }}</h2>
                    <p class="text-[#8d6e63] text-lg">{{ t('sustainability.socialResponsibility.subtitle') }}</p>
                </div>
                <div class="responsibility-tabs">
                    <ul class="flex justify-center space-x-4 border-b-2 border-gray-200 mb-8">
                        <li 
                            v-for="tab in ['community', 'farmers', 'education', 'biodiversity']" 
                            :key="tab"
                            :class="[
                                'px-6 py-4 cursor-pointer font-medium transition-colors duration-200',
                                activeTab === tab 
                                    ? 'text-[#005005] border-b-2 border-[#005005]' 
                                    : 'text-[#212121] hover:text-[#005005]'
                            ]"
                            @click="activeTab = tab"
                        >
                            {{ t(`sustainability.socialResponsibility.tabs.${tab}`) }}
                        </li>
                    </ul>
                    
                    <div class="tab-content">
                        <!-- 社区发展 -->
                        <div v-show="activeTab === 'community'" class="max-w-4xl mx-auto">
                            <div class="rounded-lg overflow-hidden shadow-lg mb-8">
                                <img src="/images/socialResponsibility/SheQuFaZhanSuoLve.png" alt="社区发展项目" class="w-full">
                            </div>
                            <div class="bg-white p-8 rounded-lg shadow-lg mb-8">
                                <div class="flex items-center mb-4">
                                    <div class="text-3xl text-[#005005] mr-4">
                                        <i class="fas fa-home"></i>
                                    </div>
                                    <h3 class="text-2xl font-semibold text-[#005005]">{{ t('sustainability.socialResponsibility.community.title') }}</h3>
                                </div>
                                <p class="text-[#212121] text-lg mb-8">{{ t('sustainability.socialResponsibility.community.description') }}</p>
                                
                                <div class="space-y-8">
                                    <div class="bg-gray-50 p-6 rounded-lg">
                                        <div class="flex items-center mb-4">
                                            <div class="text-2xl text-[#005005] mr-4">
                                                <i class="fas fa-home"></i>
                                            </div>
                                            <h4 class="text-xl font-semibold text-[#005005]">{{ t('sustainability.socialResponsibility.community.items.village.title') }}</h4>
                                        </div>
                                        <p class="text-[#212121]">{{ t('sustainability.socialResponsibility.community.items.village.content') }}</p>
                                    </div>

                                    <div class="bg-gray-50 p-6 rounded-lg">
                                        <div class="flex items-center mb-4">
                                            <div class="text-2xl text-[#005005] mr-4">
                                                <i class="fas fa-road"></i>
                                            </div>
                                            <h4 class="text-xl font-semibold text-[#005005]">{{ t('sustainability.socialResponsibility.community.items.manager.title') }}</h4>
                                        </div>
                                        <div class="space-y-2">
                                            <p class="text-[#212121]">{{ t('sustainability.socialResponsibility.community.items.manager.content1') }}</p>
                                        </div>
                                    </div>

                                    <div class="bg-gray-50 p-6 rounded-lg">
                                        <div class="flex items-center mb-4">
                                            <div class="text-2xl text-[#005005] mr-4">
                                                <i class="fas fa-hands-helping"></i>
                                            </div>
                                            <h4 class="text-xl font-semibold text-[#005005]">{{ t('sustainability.socialResponsibility.community.items.project.title') }}</h4>
                                        </div>
                                        <p class="text-[#212121]">{{ t('sustainability.socialResponsibility.community.items.project.content') }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <!-- 助农增收 -->
                        <div v-show="activeTab === 'farmers'" class="max-w-4xl mx-auto">
                            <div class="rounded-lg overflow-hidden shadow-lg mb-8">
                                <img src="/images/socialResponsibility/ZhuNongZengShouSuoLve.png" :alt="t('sustainability.socialResponsibility.farmers.imageAlt')" class="w-full">
                            </div>
                            <div class="bg-white p-8 rounded-lg shadow-lg mb-8">
                                <div class="flex items-center mb-4">
                                    <div class="text-3xl text-[#005005] mr-4">
                                        <i class="fas fa-seedling"></i>
                                    </div>
                                    <h3 class="text-2xl font-semibold text-[#005005]">{{ t('sustainability.socialResponsibility.farmers.title') }}</h3>
                                </div>
                                <p class="text-[#212121] text-lg mb-8">{{ t('sustainability.socialResponsibility.farmers.description') }}</p>
                                
                                <div class="space-y-8">
                                    <div class="bg-gray-50 p-6 rounded-lg">
                                        <div class="flex items-center mb-4">
                                            <div class="text-2xl text-[#005005] mr-4">
                                                <i class="fas fa-chalkboard-teacher"></i>
                                            </div>
                                            <h4 class="text-xl font-semibold text-[#005005]">{{ t('sustainability.socialResponsibility.farmers.items.direct.title') }}</h4>
                                        </div>
                                        <div class="space-y-2">
                                            <p class="text-[#212121]">{{ t('sustainability.socialResponsibility.farmers.items.direct.content1') }}</p>
                                            <p class="text-[#212121]">{{ t('sustainability.socialResponsibility.farmers.items.direct.content2') }}</p>
                                        </div>
                                    </div>

                                    <div class="bg-gray-50 p-6 rounded-lg">
                                        <div class="flex items-center mb-4">
                                            <div class="text-2xl text-[#005005] mr-4">
                                                <i class="fas fa-handshake"></i>
                                            </div>
                                            <h4 class="text-xl font-semibold text-[#005005]">{{ t('sustainability.socialResponsibility.farmers.items.tech.title') }}</h4>
                                        </div>
                                        <div class="space-y-2">
                                            <p class="text-[#212121]">{{ t('sustainability.socialResponsibility.farmers.items.tech.content1') }}</p>
                                            <p class="text-[#212121]">{{ t('sustainability.socialResponsibility.farmers.items.tech.content2') }}</p>
                                            <p class="text-[#212121]">{{ t('sustainability.socialResponsibility.farmers.items.tech.content3') }}</p>
                                            <p class="text-[#212121]">{{ t('sustainability.socialResponsibility.farmers.items.tech.content4') }}</p>
                                        </div>
                                    </div>

                                    <div class="bg-gray-50 p-6 rounded-lg">
                                        <div class="flex items-center mb-4">
                                            <div class="text-2xl text-[#005005] mr-4">
                                                <i class="fas fa-seedling"></i>
                                            </div>
                                            <h4 class="text-xl font-semibold text-[#005005]">{{ t('sustainability.socialResponsibility.farmers.items.value.title') }}</h4>
                                        </div>
                                        <div class="space-y-2">
                                            <p class="text-[#212121]">{{ t('sustainability.socialResponsibility.farmers.items.value.content1') }}</p>
                                            <p class="text-[#212121]">{{ t('sustainability.socialResponsibility.farmers.items.value.content2') }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <!-- 人才培养 -->
                        <div v-show="activeTab === 'education'" class="max-w-4xl mx-auto">
                            <div class="rounded-lg overflow-hidden shadow-lg mb-8">
                                <img src="/images/socialResponsibility/RenCaiPeiYangSuoLve.png" :alt="t('sustainability.socialResponsibility.education.imageAlt')" class="w-full">
                            </div>
                            <div class="bg-white p-8 rounded-lg shadow-lg mb-8">
                                <div class="flex items-center mb-4">
                                    <div class="text-3xl text-[#005005] mr-4">
                                        <i class="fas fa-graduation-cap"></i>
                                    </div>
                                    <h3 class="text-2xl font-semibold text-[#005005]">{{ t('sustainability.socialResponsibility.education.title') }}</h3>
                                </div>
                                <p class="text-[#212121] text-lg mb-8">{{ t('sustainability.socialResponsibility.education.description') }}</p>
                                
                                <div class="space-y-8">
                                    <div class="bg-gray-50 p-6 rounded-lg">
                                        <div class="flex items-center mb-4">
                                            <div class="text-2xl text-[#005005] mr-4">
                                                <i class="fas fa-graduation-cap"></i>
                                            </div>
                                            <h4 class="text-xl font-semibold text-[#005005]">{{ t('sustainability.socialResponsibility.education.items.mechanism.title') }}</h4>
                                        </div>
                                        <p class="text-[#212121]">{{ t('sustainability.socialResponsibility.education.items.mechanism.content') }}</p>
                                    </div>

                                    <div class="bg-gray-50 p-6 rounded-lg">
                                        <div class="flex items-center mb-4">
                                            <div class="text-2xl text-[#005005] mr-4">
                                                <i class="fas fa-school"></i>
                                            </div>
                                            <h4 class="text-xl font-semibold text-[#005005]">{{ t('sustainability.socialResponsibility.education.items.path.title') }}</h4>
                                        </div>
                                        <p class="text-[#212121]">{{ t('sustainability.socialResponsibility.education.items.path.content') }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <!-- 环境友好 -->
                        <div v-show="activeTab === 'biodiversity'" class="max-w-4xl mx-auto">
                            <div class="rounded-lg overflow-hidden shadow-lg mb-8">
                                <img src="/images/socialResponsibility/HuanJingYouHaoSuoLve.png" :alt="t('sustainability.socialResponsibility.biodiversity.imageAlt')" class="w-full">
                            </div>
                            <div class="bg-white p-8 rounded-lg shadow-lg mb-8">
                                <div class="flex items-center mb-4">
                                    <div class="text-3xl text-[#005005] mr-4">
                                        <i class="fas fa-leaf"></i>
                                    </div>
                                    <h3 class="text-2xl font-semibold text-[#005005]">{{ t('sustainability.socialResponsibility.biodiversity.title') }}</h3>
                                </div>
                                <p class="text-[#212121] text-lg mb-8">{{ t('sustainability.socialResponsibility.biodiversity.description') }}</p>
                                
                                <div class="space-y-8">
                                    <div class="bg-gray-50 p-6 rounded-lg">
                                        <div class="flex items-center mb-4">
                                            <div class="text-2xl text-[#005005] mr-4">
                                                <i class="fas fa-paw"></i>
                                            </div>
                                            <h4 class="text-xl font-semibold text-[#005005]">{{ t('sustainability.socialResponsibility.biodiversity.items.policy.title') }}</h4>
                                        </div>
                                        <p class="text-[#212121]">{{ t('sustainability.socialResponsibility.biodiversity.items.policy.content') }}</p>
                                    </div>

                                    <div class="bg-gray-50 p-6 rounded-lg">
                                        <div class="flex items-center mb-4">
                                            <div class="text-2xl text-[#005005] mr-4">
                                                <i class="fas fa-leaf"></i>
                                            </div>
                                            <h4 class="text-xl font-semibold text-[#005005]">{{ t('sustainability.socialResponsibility.biodiversity.items.factory.title') }}</h4>
                                        </div>
                                        <p class="text-[#212121]">{{ t('sustainability.socialResponsibility.biodiversity.items.factory.content') }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- 可持续发展报告 -->
        <section class="py-20">
            <div class="container mx-auto px-4">
                <div class="text-center mb-12">
                    <h2 class="text-3xl font-bold text-[#005005] mb-4 border-b-4 border-[#005005] inline-block pb-2">{{ t('sustainability.report.title') }}</h2>
                    <p class="text-[#8d6e63] text-lg">{{ t('sustainability.report.subtitle') }}</p>
                </div>
                <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
                    <div class="bg-white rounded-lg overflow-hidden shadow-lg p-6">
                        <h3 class="text-xl font-semibold text-[#005005] mb-2">{{ t('sustainability.report.items.2024.title') }}</h3>
                        <p class="text-[#212121] mb-4">{{ t('sustainability.report.items.2024.date') }}</p>
                        <a href="/download/2024（ESG）.pdf" target="_blank" class="inline-block px-6 py-2 bg-[#005005] text-white rounded-lg hover:bg-[#005005] transition-colors duration-200">{{ t('sustainability.report.download') }}</a>
                    </div>
                    <div class="bg-white rounded-lg overflow-hidden shadow-lg p-6">
                        <h3 class="text-xl font-semibold text-[#005005] mb-2">{{ t('sustainability.report.items.2023.title') }}</h3>
                        <p class="text-[#212121] mb-4">{{ t('sustainability.report.items.2023.date') }}</p>
                        <a href="/download/2023（ESG）.pdf" target="_blank" class="inline-block px-6 py-2 bg-[#005005] text-white rounded-lg hover:bg-[#005005] transition-colors duration-200">{{ t('sustainability.report.download') }}</a>
                    </div>
                </div>
            </div>
        </section>

        <CTA
            :title="t('sustainability.cta.title')"
            :description="t('sustainability.cta.description')"
            :buttonText="t('sustainability.cta.buttonText')"
            buttonLink="/contact"
            backgroundImage="/images/56.png"
        />
    </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import Banner from '../components/Banner.vue'
import CTA from '../components/CTA.vue'
import { useI18n } from 'vue-i18n'

const activeTab = ref('community')
const { t } = useI18n()

onMounted(() => {
    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    })
})
</script> 